export enum StateControl {
    Auto = 1,
    AutoOff = 2,
    ForceOn = 3,
    ForceOff = 4,
    AutoOn = 5,
    Restore = 6,
}